import React, { useEffect, useState } from "react";
import { Routes, Route, NavLink, Link } from "react-router-dom";
import Shop from "../../pages/Shop/Shop";
import Main from "../../pages/Main/Main";
import PersonalOrder from "../../pages/PersonalOrder/PersonalOrder";
import styles from "./Navigation.module.css";
import { useI18n } from "../../i18n/I18n";

function Navigation(): JSX.Element {
  const [open, setOpen] = useState(false);
  const { language, setLanguage, t } = useI18n();
  const links = [
    { to: "/", label: t("home"), end: true },
    { to: "/instruments", label: t("catalog") },
    { to: "/order", label: t("customOrder") },
  ];
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    const savedTheme = localStorage.getItem("muzshop-theme");
    if (savedTheme === "light" || savedTheme === "dark") return savedTheme;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("muzshop-theme", theme);
  }, [theme]);

  const preferences = (
    <div className={styles.preferences}>
      <div className={styles.language} role="group" aria-label={t("language")}>
        <button type="button" className={language === "uk" ? styles.languageActive : ""} onClick={() => setLanguage("uk")} aria-pressed={language === "uk"}>UA</button>
        <button type="button" className={language === "en" ? styles.languageActive : ""} onClick={() => setLanguage("en")} aria-pressed={language === "en"}>EN</button>
      </div>
      <button
        className={styles.themeToggle}
        type="button"
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        aria-label={theme === "dark" ? t("lightTheme") : t("darkTheme")}
        title={theme === "dark" ? t("lightTheme") : t("darkTheme")}
      >
        <span aria-hidden="true">{theme === "dark" ? "☀" : "☾"}</span>
      </button>
    </div>
  );

  return (
    <>
      <header className={styles.header}>
        <div className={`container ${styles.inner}`}>
          <Link to="/" className={styles.logo} aria-label={`muzshop — ${t("home")}`}>
            <span>muz</span>shop
          </Link>
          <button className={styles.menu} onClick={() => setOpen(!open)} aria-label={t("openMenu")} aria-expanded={open}>
            {open ? "×" : "☰"}
          </button>
          <nav className={`${styles.nav} ${open ? styles.open : ""}`} aria-label={t("navigation")}>
            {links.map((link) => (
              <NavLink key={link.to} {...link} onClick={() => setOpen(false)}
                className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}>
                {link.label}
              </NavLink>
            ))}
            <div className={styles.mobilePreferences}>{preferences}</div>
          </nav>
          <div className={styles.desktopPreferences}>{preferences}</div>
          <Link to="/instruments" className={styles.cta}>{t("chooseInstrument")}</Link>
        </div>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/instruments" element={<Shop />} />
          <Route path="/order" element={<PersonalOrder />} />
        </Routes>
      </main>
    </>
  );
}

export default Navigation;
